/*
 * Verwachte bezorgdatum op de productpagina (13-10-2026).
 *
 * Zelfde rekenregel als de verzendmethodes in de checkout (backoffice: verzendVerwachteBezorging()
 * in includes/verzend_deadline.php, cron/verzendmethode_namen.php):
 *   werkdag vóór 13:00 besteld → normaal 2 werkdagen, spoed 1 werkdag;
 *   na 13:00, in het weekend of op een feestdag telt de eerstvolgende werkdag als start.
 * Rekent in de browser en in Nederlandse tijd, omdat Shopify de pagina-HTML cachet: een datum
 * uit Liquid kan uren oud zijn. Zonder JavaScript blijft de Liquid-tekst ("1–3 werkdagen") staan.
 * Wijzigt de regel in de backoffice, dan hier ook.
 */
(() => {
  const AFKAPUUR = 13;
  const DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  const DAGEN_KORT = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  const MAANDEN = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus',
                   'september', 'oktober', 'november', 'december'];
  const MAANDEN_KORT = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

  // Datums als UTC-middag, zodat optellen nooit over een zomertijdgrens struikelt.
  const dag = (j, m, d) => new Date(Date.UTC(j, m - 1, d, 12));
  const plus = (d, n) => new Date(d.getTime() + n * 864e5);
  const sleutel = (d) => d.toISOString().slice(0, 10);

  const feestCache = {};
  function feestdagen(j) {
    if (feestCache[j]) return feestCache[j];
    // Pasen (anonieme Gregoriaanse methode)
    const a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const pasen = dag(j, Math.floor((h + l - 7 * m + 114) / 31), ((h + l - 7 * m + 114) % 31) + 1);
    const koningsdag = dag(j, 4, 27).getUTCDay() === 0 ? dag(j, 4, 26) : dag(j, 4, 27);
    const lijst = [dag(j, 1, 1), plus(pasen, 1), koningsdag, plus(pasen, 39), plus(pasen, 50), dag(j, 12, 25), dag(j, 12, 26)];
    if (j % 5 === 0) lijst.push(dag(j, 5, 5));
    return (feestCache[j] = new Set(lijst.map(sleutel)));
  }
  const isWerkdag = (d) => d.getUTCDay() % 6 !== 0 && !feestdagen(d.getUTCFullYear()).has(sleutel(d));
  function werkdagenVerder(d, n) {
    while (n > 0) { d = plus(d, 1); if (isWerkdag(d)) n--; }
    return d;
  }

  /** Nu in Nederlandse tijd: { vandaag (UTC-middag), uur } */
  function nuNL() {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date()).map((x) => [x.type, x.value]));
    return { vandaag: dag(+p.year, +p.month, +p.day), uur: +p.hour };
  }

  function bereken() {
    const { vandaag, uur } = nuNL();
    const voorAfkap = isWerkdag(vandaag) && uur < AFKAPUUR;
    const start = voorAfkap ? vandaag : werkdagenVerder(vandaag, 1);
    return { voorAfkap, normaal: werkdagenVerder(start, 2), spoed: werkdagenVerder(start, 1) };
  }

  const lang = (d) => `${DAGEN[d.getUTCDay()]} ${d.getUTCDate()} ${MAANDEN[d.getUTCMonth()]}`;
  const kort = (d) => `${DAGEN_KORT[d.getUTCDay()]} ${d.getUTCDate()} ${MAANDEN_KORT[d.getUTCMonth()]}`;

  function vul() {
    const r = bereken();
    document.querySelectorAll('[data-mk-bezorging]').forEach((el) => {
      const spoed = el.dataset.spoed === 'true';
      const normaal = el.querySelector('[data-mk-bezorg-normaal]');
      const spoedEl = el.querySelector('[data-mk-bezorg-spoed]');
      const zin = el.querySelector('[data-mk-bezorg-zin]');
      if (normaal) { const t = lang(r.normaal); normaal.textContent = `${t[0].toUpperCase()}${t.slice(1)} in huis`; }
      if (spoedEl) {
        const delen = [];
        if (r.voorAfkap) delen.push('Bestel vóór 13:00');
        if (spoed) delen.push(`${delen.length ? 'spoed' : 'Spoed'} (meerprijs): ${lang(r.spoed)}`);
        spoedEl.textContent = delen.join(' · ');
      }
      if (zin) {
        zin.textContent = `Bestel je nu${r.voorAfkap ? ' (vóór 13:00)' : ''}, dan heb je het ${lang(r.normaal)} in huis`
          + (spoed ? `, met spoedzending al ${lang(r.spoed)}.` : '.');
        zin.hidden = false;
        const oud = el.querySelector('[data-mk-bezorg-oud]');   // vaste levertijdtekst, alleen zonder JS
        if (oud) oud.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vul); else vul();
  setInterval(vul, 60000);   // om 13:00 en middernacht schuift de datum vanzelf door
})();
